import BaseComponent from '@/components/base';

export default class Loader extends BaseComponent {
  render() {
    // return `holaa aqui estoyyyy`;
    return `
      <style>
    .loading-circle {
      display: inline-block;
      width: 50px;
      height: 50px;
      border: 3px solid rgba(0, 0, 0, 0.1);
      border-radius: 50%;
      border-top-color: white;
      animation: spin 1s ease-in-out infinite;


    }

    @keyframes spin {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  </style>
  <div class="loading-circle"></div>
    `;
  }
}
